import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ApiContext } from 'lib/useApi'

class APIProvider extends Component {
  getChildContext() {
    return {
      api: this.props.api
    }
  }
  render() {
    return (
    <ApiContext.Provider value={this.props.api}>
      {React.Children.only(this.props.children)}
    </ApiContext.Provider>
    )
  }
}

export const apiProviderContextType = {
  api: PropTypes.object
}

APIProvider.propTypes = apiProviderContextType // we're just passing our props through the context
APIProvider.childContextTypes = apiProviderContextType

export default APIProvider
